import ChainApi from '../wallet/ChainApi';
import { getNftDetail } from '../api/item';
import { useToast } from "vue-toastification";

const chainApi = ChainApi;
const toast = useToast();

export async function getDefaultAvatar(addr) {
  let avatar = require('../../assets/images/default_avatar.jpg');
  sessionStorage.setItem('superAvatarNotDefaultAvatar', 0);

  let regList = await chainApi.AnswerFirst.getAllRegisterInfo(addr);
  if(regList.length) {
    let tempId = '0';
    regList.forEach(ele => {
      if(ele.tokenId != '0') {
        tempId = ele.tokenId;
      }
    });

    if(tempId != '0') {
      await getNftDetail({ 
        chain_id: process.env.VUE_APP_ENV == 'dev' ? '97' : '56',
        contract: chainApi.chainWeb3.getContractAddr('CartoonAvatar'),
        token_id: tempId,
      })
      .then(avatarRes => {
        let detailData = avatarRes.data;

        if(detailData.code == 0) {
          sessionStorage.setItem('superAvatarNotDefaultAvatar', 1);
          avatar = detailData.data.image;
        }
      })
      /*
      .catch(err => {
        console.log(err);
        toast.error(err.message ? err.message : err, { timeout: 3500 });
      });
      */
    }
  }
  sessionStorage.setItem('superAvatarDefaultAvatar', avatar);
  return avatar;
}
